import { Icon, IconProps } from "@chakra-ui/react";

function AddUserIcon(props: IconProps) {
	return (
		<Icon
			viewBox="0 0 52 53"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g filter="url(#filter0_d_3350_5643)">
				<rect
					x="2"
					y="1.5"
					width="48"
					height="48"
					rx="24"
					fill="#FAFAFA"
					shapeRendering="crispEdges"
				/>
				<rect
					x="2.5"
					y="2"
					width="47"
					height="47"
					rx="23.5"
					stroke="#D9E9FF"
					shapeRendering="crispEdges"
				/>
				<path
					opacity="0.12"
					d="M23.5 24.5C25.7091 24.5 27.5 22.7091 27.5 20.5C27.5 18.2909 25.7091 16.5 23.5 16.5C21.2909 16.5 19.5 18.2909 19.5 20.5C19.5 22.7091 21.2909 24.5 23.5 24.5Z"
					fill="#1444E1"
				/>
				<path
					d="M33 34.5V28.5M30 31.5H36M26 28.5H22C20.1362 28.5 19.2044 28.5 18.4693 28.8045C17.4892 29.2105 16.7105 29.9892 16.3045 30.9693C16 31.7044 16 32.6362 16 34.5M29.5 16.7908C30.9659 17.3841 32 18.8213 32 20.5C32 22.1787 30.9659 23.6159 29.5 24.2092M27.5 20.5C27.5 22.7091 25.7091 24.5 23.5 24.5C21.2909 24.5 19.5 22.7091 19.5 20.5C19.5 18.2909 21.2909 16.5 23.5 16.5C25.7091 16.5 27.5 18.2909 27.5 20.5Z"
					stroke="#1444E1"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<filter
					id="filter0_d_3350_5643"
					x="0"
					y="0.5"
					width="52"
					height="52"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy="1" />
					<feGaussianBlur stdDeviation="1" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
					/>
					<feBlend
						mode="normal"
						in2="BackgroundImageFix"
						result="effect1_dropShadow_3350_5643"
					/>
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect1_dropShadow_3350_5643"
						result="shape"
					/>
				</filter>
			</defs>
		</Icon>
	);
}

export default AddUserIcon;
